<template>
  <div>
    <el-button type="primary" @click="openDialog()">新增菜单</el-button>
    <el-table :data="menuList" style="width: 100%; margin-top: 20px;">
      <el-table-column prop="menuName" label="菜单名称" />
      <el-table-column prop="menuLogo" label="菜单图标">
        <template slot-scope="scope">
          <el-icon :name="scope.row.menuLogo" />
          <span style="margin-left: 8px;">{{ scope.row.menuLogo }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pageRoute" label="页面路由" />
      <el-table-column prop="permissionRoles" label="权限角色">
        <template slot-scope="scope">
          <el-tag v-for="role in scope.row.permissionRoles ? scope.row.permissionRoles.split(',') : []" 
                 :key="role" 
                 size="mini"
                 style="margin-right: 4px">
            {{ getRoleLabel(role) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="displayOrder" label="显示顺序" />
      <el-table-column prop="isActive" label="是否有效">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive === 1 ? 'success' : 'info'">
            {{ scope.row.isActive === 1 ? '有效' : '无效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.menuId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="form.menuName" />
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuLogo">
          <div v-if="form.menuLogo" style="margin-bottom: 8px;">
            <span>当前预览：</span>
            <i :class="form.menuLogo" style="font-size: 24px;"></i>
            <span style="margin-left: 8px;">{{ form.menuLogo }}</span>
          </div>
          <el-select v-model="form.menuLogo" placeholder="请选择图标">
            <el-option v-for="icon in iconList" :key="icon" :label="icon" :value="icon">
              <i :class="icon" style="margin-right: 8px;"></i>{{ icon }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面路由" prop="pageRoute">
          <el-input v-model="form.pageRoute" />
        </el-form-item>
        <el-form-item label="权限角色" prop="permissionRoles">
          <el-select v-model="form.permissionRolesList" 
                    multiple 
                    collapse-tags 
                    placeholder="请选择角色">
            <el-option
              v-for="item in roleTypeOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="显示顺序" prop="displayOrder">
          <el-input-number v-model="form.displayOrder" :min="0" />
        </el-form-item>
        <el-form-item label="是否有效" prop="isActive">
          <el-switch v-model="form.isActive" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request' // 需根据实际路径调整
import { getDictData } from '@/api/dict'

export default {
  name: 'MenuConfig',
  data() {
    return {
      menuList: [],
      dialogVisible: false,
      dialogTitle: '新增菜单',
      form: {
        menuId: '',
        menuName: '',
        menuLogo: '',
        pageRoute: '',
        permissionRoles: '',
        permissionRolesList: [], // 用于多选框的数组形式
        displayOrder: 0,
        isActive: 1
      },
      rules: {
        menuName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        menuLogo: [{ required: true, message: '请选择菜单图标', trigger: 'change' }],
        pageRoute: [{ required: true, message: '请输入页面路由', trigger: 'blur' }],
        permissionRoles: [{ required: true, message: '请选择权限角色', trigger: 'change' }]
      },
      iconList: [
        'el-icon-menu', 'el-icon-setting', 'el-icon-document', 'el-icon-user', 'el-icon-s-tools',
        'el-icon-star-off', 'el-icon-s-home', 'el-icon-s-order', 'el-icon-s-platform', 'el-icon-s-management'
      ],
      roleTypeOptions: [] // 角色类型选项
    }
  },
  watch: {
    // 监听permissionRolesList变化，自动更新permissionRoles
    'form.permissionRolesList': {
      handler(val) {
        this.form.permissionRoles = val.join(',')
      },
      deep: true
    }
  },
  created() {
    this.fetchMenuList()
    this.loadRoleTypes()
  },
  methods: {
    // 加载角色类型字典数据
    async loadRoleTypes() {
      try {
        const res = await getDictData('role_type')
        this.roleTypeOptions = res.data || []
      } catch (error) {
        console.error('加载角色类型失败:', error)
        this.$message.error('加载角色类型失败')
      }
    },
    // 获取角色标签
    getRoleLabel(value) {
      const option = this.roleTypeOptions.find(item => item.dictValue === value)
      return option ? option.dictLabel : value
    },
    fetchMenuList() {
      request.get('/menu/list').then(res => {
        this.menuList = res.data || []
      })
    },
    openDialog(row) {
      if (row) {
        this.dialogTitle = '编辑菜单'
        this.form = { 
          ...row,
          permissionRolesList: row.permissionRoles ? row.permissionRoles.split(',') : []
        }
      } else {
        this.dialogTitle = '新增菜单'
        this.form = {
          menuId: '', 
          menuName: '', 
          menuLogo: '', 
          pageRoute: '', 
          permissionRoles: '',
          permissionRolesList: [],
          displayOrder: 0, 
          isActive: 1
        }
      }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const api = this.form.menuId ? '/menu/update' : '/menu/add'
        // 提交前确保permissionRoles已更新
        this.form.permissionRoles = this.form.permissionRolesList.join(',')
        request({
          url: api,
          method: this.form.menuId ? 'put' : 'post',
          data: this.form
        }).then(() => {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.fetchMenuList()
        })
      })
    },
    handleDelete(menuId) {
      this.$confirm('确定删除该菜单吗？', '提示', { type: 'warning' })
        .then(() => {
          request.delete(`/menu/delete/${menuId}`).then(() => {
            this.$message.success('删除成功')
            this.fetchMenuList()
          })
        })
    }
  }
}
</script>

<style scoped>
.el-icon {
  margin-right: 4px;
}
.el-tag + .el-tag {
  margin-left: 4px;
}
</style> 